<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">Unfortunately, your payout request could not be processed. Please try again later.</div>
          <div class="desc">If the problem persists, please contact our support team.</div>
          <div class="buttons" style="margin-top: 24px; display: flex; gap: 12px; flex-wrap: wrap;">
            <button class="button" @click="goToOffers">
              <span>Return to My Offers</span>
            </button>
            <button class="button orange-btn" @click="goHome">
              <span>Return to Home</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'FailPayoutPage',
  methods: {
    goToOffers() {
      this.$router.push({ name: 'Profile', query: { tab: 'my-offers' } })
    },
    goHome() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped>
</style>
